import get from './get';
import update from './update';
import create from './create';

export default [get, update, create];
